import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FinalizeOrderApiService} from './finalize.order.api.service';
import {ProductDetailComponent} from './product.detail.component';
import {CgvComponent} from './cgv.component';
import {CgvService} from './cgv.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {ConfirmationDialogComponent} from '../components/dialogs/confirmation-dialog.component';

@Component({
  selector: 'app-form-order',
  templateUrl: './finalize.order.component.html',
  styleUrls: ['./finalize.order.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinalizeOrderComponent implements OnInit {
  userInfoFormGroup: FormGroup;
  billingInfoFormGroup: FormGroup;
  paymentFormGroup: FormGroup;
  isEditable = true;
  isAccepted = false;
  genders: string[] = ['MR', 'MME'];
  userInfoFormSubmitted = false;
  infoFacturation = false;
  quantity: number = 1;
  priceDecideurHt: number;
  priceCertificateReadersHt: number = 20;
  priceExpressTreatmentHt: number = 75;
  priceSerenityHt: number = 35;
  vat: number = 20;
  product: any;
  selectedOptions: { [key: string]: boolean } = {};


  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialog,
              public apiService: FinalizeOrderApiService,
              private cgvService: CgvService,
              private dialogRef: MatDialogRef<FinalizeOrderComponent>,
              private cdr: ChangeDetectorRef) {


    this.cgvService.cgvAccepted$.subscribe((accepted) => {
      console.log("accepted : >> "+ accepted );
      this.isAccepted = accepted;
    });


    this.product = data.product;

    // @ts-ignore
    this.priceDecideurHt = this.product.price;


    this.product.options_products.forEach(option => {
      this.selectedOptions[option.reference] = false;
    });



  }

  ngOnInit() {
    this.userInfoFormGroup = this.formBuilder.group({
      gender: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      emailVerification: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      country: [{value: 'France', disabled: true}, Validators.required],
      companyName: ['', Validators.required],
      siret: ['', [
        Validators.required,
        Validators.pattern(/^\d{1,14}$/)
      ]],
      address: ['', Validators.required],
      postalCode: ['', Validators.required],
      city: ['', Validators.required],
      billingInfo: [false],
    });

    this.billingInfoFormGroup = this.formBuilder.group({
      gender: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      emailVerification: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      country: [{value: 'France', disabled: true}, Validators.required],
      companyName: ['', Validators.required],
      siret: ['', [
        Validators.required,
        Validators.pattern(/^\d{1,14}$/)
      ]],
      address: ['', Validators.required],
      postalCode: ['', Validators.required],
      city: ['', Validators.required],
    });

    // this.optionsFormGroup = this.formBuilder.group({
    //   expressTreatment: [false],
    //   certificateReaders: [false],
    //   serenity: [false],
    // });


    this.paymentFormGroup = this.formBuilder.group({
      paymentOption: ['', Validators.required],
      AdministrativeMandate: ['', Validators.required],
      siret: [{value: this.userInfoFormGroup.get('siret').value, disabled: true}, [
        Validators.required,
        Validators.pattern(/^\d{1,14}$/)
      ]],
      serviceCode: ['', Validators.required],
      ChorusOrderNumber: ['', Validators.required],
      bankTransfer: ['', Validators.required],
      TransferReference: ['', Validators.required],
      bankCheck: ['', Validators.required],
      checkNumber: ['', Validators.required],
      bankName: ['', Validators.required],
    });

    // this.cgvService.cgvAccepted$.subscribe((accepted) => {
    //   this.isAccepted = accepted;  // Met à jour l'état de la checkbox lorsque l'état des CGV change
    // });
  }

  emailMatchValidator(group: FormGroup): { [key: string]: boolean } | null {
    const email = group.get('email');
    const emailVerification = group.get('emailVerification');
    return email && emailVerification && email.value !== emailVerification.value
      ? {emailMismatch: true}
      : null;
  }

  onSubmit() {
    this.userInfoFormSubmitted = true;

    console.log(this.userInfoFormGroup);

    if (this.userInfoFormGroup.valid) {
      console.log('Formulaire valide et soumis.');
    } else {
      console.log('Formulaire invalide.');
    }
  }

  validateQuantity(value: string): number {
    // Nettoyer et convertir en nombre
    const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 2);
    const numericValue = Number(sanitizedValue);

    // Garantir une valeur entre 1 et 99
    if (numericValue < 1) return 1;
    if (numericValue > 99) return 99;

    return numericValue;
  }

  enforceMaxLength(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Valider et mettre à jour la quantité
    this.quantity = this.validateQuantity(input.value);

    // Mettre à jour l'input si nécessaire
    input.value = this.quantity.toString();
  }

  showSelectedOptions(opt: any): void {
    console.log(opt)
    console.log(this.getSelectedOptions())
  }

  getSelectedOptions(): any[] {

    return this.product.options_products.filter(option => this.selectedOptions[option.reference]);
  }

  finalPriceHt(): number {
    // Récupérer les options sélectionnées et calculer leur coût total
    const selectedOptions = this.getSelectedOptions();
    const optionsCost = selectedOptions.reduce((total, option) => total + (option.price), 0);


    // Calculer le prix final (prix de base + coût des options) * quantité
    const finalPrice = (this.priceDecideurHt + optionsCost) * this.quantity;

    return finalPrice;
  }

  isStepValid(): FormGroup {
    const isBillingInfoPresent = this.userInfoFormGroup.get('billingInfo').value;
    return this.userInfoFormGroup.invalid && !isBillingInfoPresent
      ? this.userInfoFormGroup
      : isBillingInfoPresent && this.billingInfoFormGroup.invalid
        ? this.billingInfoFormGroup
        : this.userInfoFormGroup;
  }

  administrativeMandateIsAvailable(): true | false {
    this.paymentFormGroup.get('siret').setValue(this.userInfoFormGroup.get('siret').value);
    if (this.userInfoFormGroup.get('siret').value && (this.userInfoFormGroup.get('siret').value.startsWith('1') || this.userInfoFormGroup.get('siret').value.startsWith('2'))) {
      return true
    }
    return false;
  }


  SendCertificateorder() {
    console.log(this.userInfoFormGroup);
    console.log(this.getSelectedOptions());
    console.log(this.paymentFormGroup);
    console.log(this.paymentFormGroup.get('paymentOption')?.value);
    const getCivility = (gender: string): string => {
      switch (gender.toUpperCase()) {
        case 'MR':
          return 'mr';
        case 'MME':
          return 'mrs';
        default:
          return gender.toLowerCase();
      }
    };
    // Utilitaire pour créer des objets d'identité avec gestion de `civility`
    const createIdentityObject = (formGroup: FormGroup) => ({
      address: formGroup.get('address')?.value || '',
      capacity: '',
      city: formGroup.get('city')?.value || '',
      civility: getCivility(formGroup.get('gender')?.value || ''),
      company: {
        name: formGroup.get('companyName')?.value || '',
        identifier: formGroup.get('siret')?.value || '',
        identifier_iso6523: '0002',
      },
      country: formGroup.get('country')?.value || '',
      email: formGroup.get('email')?.value || '',
      firstname: formGroup.get('firstName')?.value || '',
      lastname: formGroup.get('lastName')?.value || '',
      phone: formGroup.get('phone')?.value || '',
      postal_code: formGroup.get('postalCode')?.value || '',
      region: formGroup.get('city')?.value || '',
    });

    // Fonction pour convertir civility


    // Construire les objets identity et billing
    const identity = createIdentityObject(this.userInfoFormGroup);
    const billing = this.paymentFormGroup.get('billingInfo')?.value
      ? createIdentityObject(this.billingInfoFormGroup)
      : identity;

    // Construire les options de produit
    const optionsProduct = this.getSelectedOptions().map((option: any) => ({
      reference: option.reference,
      quantity: this.quantity,
    }));

    // Construire le produit principal
    const orderProduct = {
      reference: this.product.reference,
      quantity: this.quantity,
      options_products: optionsProduct,
    };

    // Construire l'objet de paiement
    const paymentOption = this.paymentFormGroup.get('paymentOption')?.value;
    const objPayment: any = {
      amount: this.finalPriceHt(),
      vat: 20.0, // Toujours au format double
      type: '',  // Défaut vide, mis à jour ci-dessous
      data: '',  // Défaut vide, mis à jour ci-dessous
    };

    // Configuration spécifique à chaque type de paiement

    console.log(paymentOption);
    if (paymentOption === '1') {
      console.log("paymentOption    ===> " +paymentOption);
      objPayment.type = 'mandate';
      // objPayment.data = {
      //   chorus_order: this.paymentFormGroup.get('ChorusOrderNumber')?.value || '',
      //   chorus_code: this.paymentFormGroup.get('serviceCode')?.value || '',
      // };

      objPayment.data = JSON.stringify({
        chorus_order: this.paymentFormGroup.get('ChorusOrderNumber')?.value || '',
        chorus_code: this.paymentFormGroup.get('serviceCode')?.value || '',
      });
      console.log(objPayment);
    } else if (paymentOption === '2') {
      console.log("paymentOption    ===> " +paymentOption);
      objPayment.type = 'transfer';
      // objPayment.data = {
      //   transfer_reference: this.paymentFormGroup.get('TransferReference')?.value || '',
      // };
      objPayment.data = JSON.stringify({
        transfer_reference: this.paymentFormGroup.get('TransferReference')?.value || '',
      });
      console.log(objPayment);
    } else if (paymentOption === '3') {
      console.log("paymentOption    ===> " +paymentOption);
      objPayment.type = 'check';
      // objPayment.data = {
      //   bank_name: this.paymentFormGroup.get('bankName')?.value || '',
      //   check_number: this.paymentFormGroup.get('checkNumber')?.value || '',
      // };
      objPayment.data = JSON.stringify({
        bank_name: this.paymentFormGroup.get('bankName')?.value || '',
        check_number: this.paymentFormGroup.get('checkNumber')?.value || '',
      });

      console.log(objPayment);
    }
    console.log(objPayment);
    // Construire l'objet final de commande
    const objOrder = {
      billing: billing,
      customer: identity,
      payment: objPayment,
      product: orderProduct,
    };

    // Log pour vérifier la structure de l'objet avant l'envoi
    console.log('Commande à envoyer:', objOrder);

    // Envoi de la commande via le service API
    this.apiService.SendCertificateorder(objOrder).subscribe(
      (data) => {
        // console.log('Commande envoyée avec succès :', data);
        console.log(data);
        const dialogConfirm = this.dialog.open(ConfirmationDialogComponent, {
          width: '500px',
          height: '196px',
          data: { message: 'Voulez-vous vraiment continuer ?'},
          panelClass: 'custom-confirmation-dialog-container'
        });
        dialogConfirm.afterClosed().subscribe(result => {
          console.log('Le dialogue a été fermé');
          console.log('Résultat :', result);
          if (result === 'confirm') {
            // Logique en cas de confirmation
            window.open(data.certificate_order.orderUrl, '_blank');
            this.dialogRef.close('confirm');
          } else {
            // Logique en cas d'annulation
            console.log('Action annulée.');
          }
        });
      },
      (err) => {
        console.error('Erreur lors de l\'envoi de la commande :', err);
      }
    );
  }


  isFormValid(): boolean {
    return !(
      (this.userInfoFormGroup.invalid && !this.userInfoFormGroup.get('billingInfo')?.value) ||
      (this.userInfoFormGroup.get('billingInfo')?.value && this.billingInfoFormGroup.invalid)
    );
  }

// Vérifie si l'objet payment est bien renseigné (type, montant, etc.)
  isPaymentValid(): boolean {
    const paymentOption = this.paymentFormGroup.get('paymentOption')?.value;

    // Vérifier si l'option de paiement et les données associées sont valides
    if (paymentOption === '1') {
      return this.paymentFormGroup.get('ChorusOrderNumber')?.value && this.paymentFormGroup.get('serviceCode')?.value;
    } else if (paymentOption === '2') {
      return this.paymentFormGroup.get('TransferReference')?.value;
    } else if (paymentOption === '3') {
      return this.paymentFormGroup.get('bankName')?.value && this.paymentFormGroup.get('checkNumber')?.value;
    }

    // Si aucune option n'est sélectionnée ou invalides, retourner false
    return false;
  }

  setAcceptedCgv (bool: boolean) {

    console.log("setAcceptedCgv bool ===>" + bool);
    this.isAccepted = bool;
  }

  cgvDetail(event: MatCheckboxChange): void {

    console.log(event.checked);
    if(!event.checked){

      this.setAcceptedCgv(false);
      event.source.checked = false;
      this.cdr.detectChanges();
    } else{
      console.log("cgvDetail");
      const dialogRef = this.dialog.open(CgvComponent, {
        width: '750px', // Largeur fixe
        height: '600px',
        data: {
          isAccepted: !event.checked
        },// Largeur fixe
      });

      dialogRef.afterClosed().subscribe(result => {

        console.log(result)
        // this.cgvService.cgvAccepted$.subscribe((accepted) => {
        //   console.log(accepted);
        //   this.isAccepted = accepted; // Met à jour la case à cocher si CGV sont acceptées
        // });

        if (result) {
          this.setAcceptedCgv(true); // Mettre à jour la valeur en fonction du retour
          console.log('CGV Accepted:', result);
        } else {
          this.setAcceptedCgv(false);
          event.source.checked = false;
          console.log('CGV Refused or no action taken');
        }
        this.cdr.detectChanges();
      });
    }

  }
}
